<template>
  <span
    class="dot-indicator"
    :class="{ 'dot-indicator--active': active }"
  ></span>
</template>

<script>
export default {
  name: 'DotIndicator',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.dot-indicator {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #8B95A1;
  transition: background 0.2s ease;
}

.dot-indicator--active {
  background: #18181C;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/DotIndicator.vue